import React from 'react';
import Divider from './Divider';
import Announcement from './Announcement';
import '../css/Home.css';

const Home03 = () => {
    const heading = 'ANNOUNCEMENTS';


    return (
        <div className='home03-container flex-center'>
            <div className='home03-headline-container'>
                <div className='home01-tagline palanquin-dark bold primary-yellow-text'>{heading}</div>
            </div>
            <Divider width='350' color='#FFFFFF' />
            <Announcement/>
        </div>
    );
};

export default Home03;